import { Typography } from "@mui/material";
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';

const ErrorDisplay = ({error}) => {
  console.log(error);
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, height: 60 }}>
        <ErrorIcon color="error" fontSize="large" />
        <Typography variant="h4">An Error Occurred: {error.errorCode}</Typography>
      </Box>
      <Typography variant="h5">{error.errorMessage}</Typography>
    </>
  );
}

export default ErrorDisplay;
